import type { SetupContext } from 'vue';
import type { AttractScreenEvents, AttractScreenProps } from './types';

export function useAttractController(
  emit: SetupContext<AttractScreenEvents>['emit'],
  props: AttractScreenProps
) {
  return {
    selectGroup: (groupId: string) => emit('selectGroup', groupId),
    openScan: () => {
      if (props.canOpenScan === false) return;
      emit('openScan');
    },
    help: () => emit('help'),
  };
}
